import { Question, QuestionType } from '@synergetx/puppet-interview-types';

export const DEFAULT_NEW_QUESTION = (position: number): Question => ({
    position,
    name: '',
    askWhichOne: false,
    afterSelection: 'none',
    type: QuestionType.PUPPET,
    localeContent: {},
});
